export default __webpack_public_path__ + "static/media/pen-paper.4500b691.glb";